import http from "./http.js";

// 受邀嘉宾报名系列活动
export function invitedGuestEnroll(id) {
    return http.postRequestToken("/uc/activity/invitedGuestEnroll", {
        id: id
    })
}

// 受邀嘉宾查看系列活动列表
export function invitedGuestActivities(params) {
    return http.postRequestToken("/uc/activity/invitedGuestActivities", params)
}

// 嘉宾取消报名系列活动列表
export function cancelEnroll(id) {
    return http.postRequestToken("/uc/activity/cancelEnroll", {
        id: id
    })
}

// 个人嘉宾报名系列活动
export function normalGuestEnroll(id, guestId) {
    return http.postRequestToken("/uc/activity/normalGuestEnroll", {
        id: id,
        guestId: guestId
    })
}

// 个人嘉宾查看系列活动列表
export function normalGuestActivities(params) {
    return http.postRequestToken("/uc/activity/normalGuestActivities", params)
}